'use client';

import { LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
  type ChartConfig,
} from '../chart';
// Shared with line-label-chart — same shape; re-declaring + re-exporting it
// here made the charts barrel (`export *`) ambiguous (TS2308). Import only
// (do NOT re-export) so the barrel exposes the single line-label copy.
import type { LineSeries } from './line-label-chart';

interface LineLinearChartProps {
  data: Record<string, unknown>[];
  series: LineSeries[];
  xKey: string;
  showLegend?: boolean;
  height?: number;
  className?: string;
}

export function LineLinearChart({
  data,
  series,
  xKey,
  showLegend = true,
  height = 260,
  className,
}: LineLinearChartProps) {
  const config: ChartConfig = Object.fromEntries(
    series.map((s) => [s.key, { label: s.label, color: s.color }]),
  );

  return (
    <ChartContainer config={config} className={className} style={{ height }}>
      <LineChart data={data} margin={{ top: 8, right: 20, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey={xKey} tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} width={36} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {showLegend && <ChartLegend content={<ChartLegendContent />} />}
        {series.map((s) => (
          <Line
            key={s.key}
            type="linear"
            dataKey={s.key}
            stroke={`var(--color-${s.key})`}
            strokeWidth={2}
            dot={false}
          />
        ))}
      </LineChart>
    </ChartContainer>
  );
}
